import { AppModule } from 'app/module';
import { API_ENDPOINT_JOBS_BY_IDS } from 'app/endpoints';
import { SuggestionListItem } from 'module/suggestionListItem/main';
import { Base64Link } from 'module/base64Link/main';
import { VisitedJobsHistory } from 'util/client-side-storage/visitedJobsHistory';
import { getJson } from 'util/xhr';
import Template from './template.hbs';
import './styles.scss';

const numberOfItemsToLoad = 3;

export class SuggestionList extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    ready() {
        if (this.props.lazy && this.props.recentJobs) {
            app.events.on('firstUserInteraction', () => this.loadRecentJobs());
        }
    }

    async loadRecentJobs() {
        const ids = (await VisitedJobsHistory.getJobIds())
            .filter((id) => id !== this.props.jobId)
            .splice(0, numberOfItemsToLoad);
        if (!ids || ids.length === 0) return;

        const queryString = ids.reduce((acc, id) => `${acc}jobIds[]=${id}&`, '?').slice(0, -1);
        getJson(API_ENDPOINT_JOBS_BY_IDS + queryString, {}, this.onResponse.bind(this));
    }

    onResponse(response) {
        if (!response || !Array.isArray(response)) return;
        const items = response.map((item) => ({ jobsItem: { ...item.jobsItem, isRecentlyVisited: true } }));
        this.updateProps({
            items,
            hidden: false,
        }, true);
    }

    domBindings() {
        this.dom.suggestionListItems = this.dom.el.querySelectorAll('.m-suggestionListItem');
        this.dom.headline = this.dom.el.querySelector('.m-suggestionList__headline');
        this.dom.moreLink = this.dom.el.querySelector('.m-suggestionList__moreJobsLinkWrapper .m-base64Link');
        this.dom.moreLinkMobile = this.dom.el
            .querySelector('.m-suggestionList__moreJobsLinkWrapperMobile .m-base64Link');

        // SuggestionListItems instances are needed in `getPropsFromDom()` which runs before `subs()`.
        this.suggestionListItems = [];
        if (this.dom.suggestionListItems) {
            for (let i = 0; i < this.dom.suggestionListItems.length; i += 1) {
                this.suggestionListItems[i] = new SuggestionListItem(this.dom.suggestionListItems[i]);
            }
        }
    }

    subs() {
        if (this.dom.moreLink) {
            this.link = new Base64Link(this.dom.moreLink);
        }

        if (this.dom.moreLinkMobile) {
            this.linkMobile = new Base64Link(this.dom.moreLinkMobile);
        }
    }

    getPropsFromDom() {
        const items = this.getItemsProps();
        return {
            active: !!this.dom.el,
            recentJobs: this.dom.el.hasAttribute('data-isRecentJobs'),
            lazy: this.dom.el.hasAttribute('data-lazy'),
            jobId: this.dom.el.getAttribute('data-jobId') ?? -1,
            items,
            hasMoreJobs: !!this.dom.moreLink,
            isLandingPage: this.dom.moreLink?.classList.contains('m-suggestionList__link--landingpage') ?? false,
            linkText: this.dom.moreLink ? this.dom.moreLink.innerText : '',
            link: this.dom.moreLink
                ? window.atob(this.dom.moreLink.querySelector('.m-base64Link__a').getAttribute('data-link')) : false,
            headline: this.dom.headline ? this.dom.headline.innerText : '',
        };
    }

    getItemsProps() {
        const suggestionListProps = {};
        if (this.suggestionListItems) {
            for (let i = 0; i < this.suggestionListItems.length; i += 1) {
                suggestionListProps[i] = {
                    jobsItem: {},
                };
                suggestionListProps[i].jobsItem = this.suggestionListItems[i].getPropsFromDom();
            }
        }
        return suggestionListProps;
    }
}
